import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const DEPOSIT_TOUR_ID = 'deposit';

export const depositSteps: StepType[] = [
  {
    selector: '[data-tour="wallet-clabe"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="right" showPointer={false}>
        Esta es tu <strong>CLABE interbancaria</strong> de 18 dígitos. Cópiala y haz una
        transferencia desde tu banco — el saldo aparece en minutos.
      </MascotBubble>
    ),
  },
];
